import React from 'react';
import { Education } from '../../../../../types/resume';
import { GraduationCap, MapPin, Calendar, Trophy, Trash2 } from 'lucide-react';
import Input from '../../../../ui/Input';
import AchievementList from './AchievementList';

interface Props {
  education: Education;
  index: number;
  onUpdate: (id: string, updates: Partial<Education>) => void;
  onRemove: (id: string) => void;
}

export default function EducationItem({ education, index, onUpdate, onRemove }: Props) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-semibold">Education {index + 1}</h3>
        <button
          onClick={() => onRemove(education.id)}
          className="text-red-500 hover:text-red-600"
        >
          <Trash2 className="h-5 w-5" />
        </button>
      </div>

      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="relative">
            <GraduationCap className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="School"
              value={education.school}
              onChange={(e) => onUpdate(education.id, { school: e.target.value })}
              placeholder="University Name"
              className="pl-10"
              required
            />
          </div>
          <div className="relative">
            <MapPin className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="Location"
              value={education.location}
              onChange={(e) => onUpdate(education.id, { location: e.target.value })}
              placeholder="City, Country"
              className="pl-10"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Degree"
            value={education.degree}
            onChange={(e) => onUpdate(education.id, { degree: e.target.value })}
            placeholder="Bachelor's, Master's, etc."
            required
          />
          <Input
            label="Field of Study"
            value={education.field}
            onChange={(e) => onUpdate(education.id, { field: e.target.value })}
            placeholder="Computer Science, Business, etc."
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="relative">
            <Calendar className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              type="month"
              label="Graduation Date"
              value={education.graduationDate}
              onChange={(e) => onUpdate(education.id, { graduationDate: e.target.value })}
              className="pl-10"
              required
            />
          </div>
          <div className="relative">
            <Trophy className="absolute left-3 top-9 h-5 w-5 text-gray-400" />
            <Input
              label="GPA (Optional)"
              value={education.gpa}
              onChange={(e) => onUpdate(education.id, { gpa: e.target.value })}
              placeholder="3.8/4.0"
              className="pl-10"
            />
          </div>
        </div>

        <AchievementList
          achievements={education.achievements}
          onUpdate={(achievements) => onUpdate(education.id, { achievements })}
        />
      </div>
    </div>
  );
}